import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/data";

export default function WhatsAppFab() {
  return (
    <a
      data-testid="whatsapp-fab"
      href={`https://wa.me/${CONTACT.phoneRaw}?text=Hello%20Shramik%20Group%2C%20I%20would%20like%20to%20know%20more.`}
      target="_blank" rel="noreferrer"
      className="fixed z-40 bottom-6 right-6 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500/40 blur-xl group-hover:blur-2xl transition-all" />
      <span className="relative w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 flex items-center justify-center shadow-xl shadow-emerald-500/30">
        <MessageCircle className="w-6 h-6 text-white" />
      </span>
    </a>
  );
}
